<template>
  <div class="personal">

    <!-- [ Personal form ] start -->
    <el-row  :gutter="20" type="flex" justify="center">
      <el-col :span="24">
        <el-form :model="form" status-icon :rules="rules" ref="form" size="mini" label-width="0" class="demo-ruleForm">

          <el-form-item prop="countryId">
            <el-select
              no-data-text="No data"
              v-model="form.countryId"
              @visible-change="loadCountryList"
              placeholder="Select Country"
              filterable
              style="width: 100%;">
              <el-option
                v-for="item in countryList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                @click.native="setState(item)">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="stateId">
            <el-select
              no-data-text="No data"
              v-model="form.stateId"
              @visible-change="loadStateList"
              placeholder="Select State"
              filterable
              style="width: 100%;">
              <el-option
                v-for="item in stateList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
                @click.native="setCity(item)">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="cityId">
            <el-select
              no-data-text="No data"
              v-model="form.cityId"
              @visible-change="loadCityList"
              placeholder="Select City"
              filterable
              style="width: 100%;">
              <el-option
                v-for="item in cityList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="timezoneId">
            <el-select
                placeholder="Select Timezone"
                no-data-text="No data"
                v-model="form.timezoneId"
                @visible-change="loadTimezoneList"
                filterable
                style="width: 100%;">
              <el-option
                  v-for="item in timezoneList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                <span style="float: left">{{ item.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.gmtOffsetName }}</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="email">
            <el-input v-model="form.email" label="Email"></el-input>
          </el-form-item>

          <el-form-item prop="password">
            <el-input type="password" v-model="form.password" label="Password" show-password></el-input>
          </el-form-item>

          <el-form-item prop="firstname">
            <el-input v-model="form.firstname" label="First Name"></el-input>
          </el-form-item>

          <el-form-item prop="lastname">
            <el-input v-model="form.lastname" label="Last Name"></el-input>
          </el-form-item>

          <el-form-item prop="code">
            <el-input v-model="form.code" label="(Optional) Enter Your Support Code"></el-input>
          </el-form-item>

          <el-form-item class="text-align-left">
            <el-switch v-model="form.checkbox"></el-switch> I have read and I agree to the <span class="link-terms" @click="openLink('termsOfUse')"> terms of use</span>, <span class="link-terms" @click="openLink('privacyNotice')">privacy notice</span> and <span class="link-terms" @click="openLink('offerDetails')">offer details</span>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="width-100" @click="submitForm('form')" :disabled="!form.checkbox">{{$t('auth_btn_sign_up')}}</el-button>
          </el-form-item>

        </el-form>
      </el-col>
    </el-row>
    <!-- [ Personal form ] end -->

    <info-modal ref="infoModal" :title="info.title">
      <div v-html="info.text"></div>
    </info-modal>

  </div>
</template>

<script>
import axios from 'axios'
import InfoModal from '@/components/InfoModal.vue'
  export default {
    name: 'personal',
    components: {
      InfoModal,
    },
    props: {
      linksList: {
        type: Object,
        default: function () {
          return {}
        }
      },
    },
    data() {
      return {
        info: {
          title: '',
          text: ''
        },

        form: {
          email: '',
          password: '',
          firstname: '',
          lastname: '',
          code: '',
          checkbox: false,

          countryId: null,
          stateId: null,
          cityId: null,
          timezoneId: null,
        },

        countryList: [],
        stateList: [],
        cityList: [],
        timezoneList: [],

        rules: {
          email: [
            { required: true, message: 'Please input Email address', trigger: 'blur' },
            { type: 'email', message: 'Please input correct email address', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'Please input Password', trigger: 'blur' },
            { min: 8, message: 'Length should be 8', trigger: 'blur' }
          ],
          firstname: [
            { required: true, message: 'Please input your First Name', trigger: 'blur' },
          ],
          lastname: [
            { required: true, message: 'Please input your Last Name', trigger: 'blur' },
          ],
          countryId: [
            { required: true, message: 'Please input your Country', trigger: 'change' },
          ],
          stateId: [
            { required: true, message: 'Please input your State', trigger: 'change' },
          ],
          cityId: [
            { required: true, message: 'Please input your City', trigger: 'change' },
          ],
          timezoneId: [
            { required: true, message: 'Please input your Timezone', trigger: 'change' },
          ]
        }
      }
    },
    methods: {
      openLink(name) {
        this.info.title = this.linksList[name].translations[0].titleTranslation
        this.info.text = this.linksList[name].translations[0].textTranslation
        this.$refs['infoModal'].openModal()
      },
      setState(item) {
        this.form.stateId = null
        this.form.cityId = null
        this.stateList = []
        this.cityList = []
      },
      setCity(item) {
        this.form.cityId = null
        this.cityList = []
      },
      loadList(type, id, arrType) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/country/directories?type=${type}&id=${id}`)
          .then(response => {
            this[arrType] = response.data.list
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      loadCountryList(isVisiable) {
        if (isVisiable && this.countryList.length < 2) {
          this.loadList('country', null, 'countryList')
        }
      },
      loadStateList(isVisiable) {
        if (isVisiable && this.stateList.length < 2) {
          this.loadList('state', this.form.countryId, 'stateList')
        }
      },
      loadCityList(isVisiable) {
        if (isVisiable && this.cityList.length < 2) {
          this.loadList('city', this.form.stateId, 'cityList')
        }
      },
      async loadTimezoneList(isVisiable) {
        if (isVisiable && this.timezoneList.length < 2) {
          let loader = this.$loading.show();
          try {
            const { data } = await axios.post('/api/v1/users/directories?operation=updateMe');
            this.timezoneList = data.timezoneList
            loader.hide()
          } catch (error) {
            loader.hide()
          }
        }
      },
      submitForm(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            let loader = this.$loading.show();
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post('/api/v1/auth/register', {
                accountType: '1',
                email: this.form.email,
                password: this.form.password,
                firstname: this.form.firstname,
                lastname: this.form.lastname,
                code: this.form.code,
                companyName: '',
                countryId: this.form.countryId,
                stateId: this.form.stateId,
                cityId: this.form.cityId,
                timezoneId: this.form.timezoneId,
              })
              .then(response => {
                // Handle success.
                console.log('Your user received an email');
                console.log('---', response.data);
                this.notification("Success", "Confirmation mail has send to you, please check your email", "success")

                this.$router.push('/login');
                loader.hide()
              })
              .catch(error => {
                // Handle error.
                // console.log('An error occurred:', error);
                // this.notification("Notification", error.response.data.message, "info")
                loader.hide()
              });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      }
    }
  }
</script>

<style lang="scss" scoped>
.personal {
  text-align: center;
  .text-align-left {
    text-align: left;
  }
  .width-100 {
    width: 100%;
  }
  .mb {
  margin-bottom: 20px;
  }
  .checkbox {
    // line-height: 1.6;
    color: #5B5B5B;
  }
}

.footer__link {
  line-height: 1.6;
  color: #4D4C4C;
}
</style>
